import { hasMappedCvnaFeatures } from '~/utilities/vdp/whyBuyNarrative';
import useGetVaultWhyBuyNarrative from './useGetVaultWhyBuyNarrative';
import useHasVaultWhyBuyData from './useHasVaultWhyBuyData';

export default function useHasMappedWhyBuyFeatures(): boolean {
  const hasVaultWhyBuyData = useHasVaultWhyBuyData();
  const { narrativeContent } = useGetVaultWhyBuyNarrative();

  return hasVaultWhyBuyData && hasMappedCvnaFeatures(narrativeContent);
}
